"use client";

import { openCookiePreferences } from "@/lib/consent";

export type CookieSettingsLinkProps = {
	label: string;
	className?: string;
};

export function CookieSettingsLink({
	label,
	className,
}: CookieSettingsLinkProps) {
	return (
		<button
			type="button"
			onClick={() => openCookiePreferences()}
			className={
				className ??
				"hover:text-primary transition-colors text-left cursor-pointer bg-transparent border-0 p-0 font-inherit"
			}
		>
			{label}
		</button>
	);
}
